<template>
  <v-main class="fill-height d-flex v-application v-application v-application--is-ltr theme--light">
    <div data-app style="flex: 1 1 auto;
    max-width: 100%;
    position: relative;
display: flex;
flex-direction: column;
height: 100%;">
      <v-row  class="m-0 mb-1 elevation-1" style="max-height: 2.55rem">
        <v-col class="p-0">
          <v-row class="m-0" style="height: 2.55rem">
            <span style="margin-top: auto;
                     margin-bottom: auto; margin-left: 12px;" class="text-h5">Leistungsarten</span>
            <v-btn
                v-if="isDetail"
                icon
                color="blue"
                style="margin-top: auto; margin-bottom: auto; margin-left: 24px"
                :disabled="this.currentItemIndex === 0"
                @click="moveSelection('left', true)"
            >
              <v-icon>mdi-page-first</v-icon>
            </v-btn>
            <v-btn
                v-if="isDetail"
                icon
                color="blue"
                style="margin-top: auto; margin-bottom: auto;"
                :disabled="this.currentItemIndex === 0"
                @click="moveSelection('left', false)"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn
                v-if="isDetail"
                icon
                color="blue"
                style="margin-top: auto; margin-bottom: auto;"
                :disabled="this.currentItemIndex === this.lears.length - 1"
                @click="moveSelection('right', false)"

            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
            <v-btn
                v-if="isDetail"
                icon
                color="blue"
                style="margin-top: auto; margin-bottom: auto;"
                :disabled="this.currentItemIndex === this.lears.length - 1"
                @click="moveSelection('right', true)"
            >
              <v-icon>mdi-page-last</v-icon>
            </v-btn>
            <div class="t-btn-left"></div>
            <import-export-button
                class="t-btn"
                profile="LEAR"
                :api-prefix="ioPrefix"
                :disabled="isEdit"
            />
            <v-btn
                block
                color="success"
                class="white--text t-btn"
                :disabled="isEdit"
                @click="toggleDetails"
                v-if="singleEdit"
            >
              <v-icon left>
                {{isDetail ? 'mdi-view-list' : 'mdi-eye-outline'}}
              </v-icon>
              {{isDetail ? 'Liste' : 'Details'}}
            </v-btn>
            <v-btn
                v-if="(!isEdit || !singleEdit) && false"
                block
                color="error"
                class="t-btn"
                :disabled="!hasSelects"
            >
              <v-icon left>
                mdi-delete
              </v-icon>
              Löschen
            </v-btn>
            <v-btn
                v-if="!isEdit || !singleEdit"
                class="white--text t-btn"
                color="primary"
                block
                @click="addRow"
            >
              <v-icon left>
                mdi-plus-circle-outline
              </v-icon>
              Anlegen
            </v-btn>
            <v-btn
                v-if="isEdit"
                block
                color="warning"
                class="t-btn"
                @click="resetEdit"
            >
              <v-icon left>
                mdi-close-circle-outline
              </v-icon>
              Abbrechen
            </v-btn>
            <v-btn
                v-if="isEdit || !singleEdit"
                block
                color="success"
                class="white--text t-btn"
                :disabled="!isEdit"
                @click="onSave"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Speichern
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-row class="m-0" style="flex: 0 0 auto;">
        <v-col class="p-0">
          <spread-sheet v-if="!isDetail" ref="spreadsheet" id="spreadsheet"
                        :collumns="cols" :data="lears"
                        :temp-col-width="10"
                        :is-single-edit="singleEdit"
                        @change="dataChanged"
                        @selection-change="selectionChange"
                        @dbl-click="dblClick"
                        style="margin-top: -1px"/>
          <lear-detail v-else ref="detail" id="detail" :item="currentLear" :lears="lears" :legrs="legrs"  :ezs="ezs" @change="dataChanged"/>
        </v-col>
      </v-row>
    </div>
    <v-snackbar
        v-model="showErrorMessage"
        :timeout="5000"
        right
        color="red accent-2"
    >
      <b>{{ errorMessage }}</b>

      <template v-slot:action="{ attrs }">
        <v-btn
            icon
            color="white"
            v-bind="attrs"
            @click="showErrorMessage = false"
        >
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-main>
</template>

<script>
import {Redirect_500, Redirect_Login, Server_URL} from "@/shared/utils";
import {DateTime as LuxonDateTime} from "luxon";
import SpreadSheet from "@/views/basis_data/common/SpreadSheet.vue";
import LearDetail from "@/views/basis_data/lear_detail.vue";
import ImportExportButton from "@/views/basis_data/import_export/ImportExportButton.vue";
import {v4, v4 as uuidv4} from 'uuid';



export default {
  name: "lear_list",
  components: {
    SpreadSheet,
    LearDetail,
    ImportExportButton,
  },
  data () {
    return {
      cols: [
        {type: 'readonly', title: 'Laufende Nummer', name: 'bis_id', width: '30', readOnly: true},
        {type: 'text', title: 'Name', name: 'name', width: '200', required: true, max_length: '50'},
        {type: 'dropdown', title: 'Leistungsgruppe', name: 'legr', width: '200', required: true, max_length: '50', source: []},
        {type: 'dropdown', title: 'Erschwerniszulage', name: 'lohn_surcharge', width: '200', required: false, max_length: '50', source: []},
      ],
      lears: [],
      legrs: [],
      ezs: [],
      loader: undefined,
      singleEdit: true,
      hasSelects: false,
      isEdit: false,
      editId: '',
      isDetail: false,
      itemId: null,
      currentLear: null,
      currentItemIndex: null,
      isAdmin: false,
      errorMessage: '',
      showErrorMessage: false,
      ioPrefix: Server_URL + '/auftragsbuch/basis_data/io',
    }
  },
  mounted () {
  },
  created() {
    this.isAdmin = this.$cookies.get("ps_username") === 'admin';
    this.showLoader();
    this.$http.get(
        Server_URL + '/auftragsbuch/basis_data/lears'
    ).then(this.responseOkGet, this.responseError)
  },
  computed: {

  },
  methods: {
    onSave() {
      let data = [];
      if (this.isDetail) {
        data = [this.$refs.detail.getData()];
      } else if (this.singleEdit) {
        data = [this.$refs.spreadsheet.getData(this.editId)]
      } else {
        data = this.$refs.spreadsheet.getAllData();
      }
      for (let i = 0; i < data.length; i++) {
        data[i].name = data[i].name.trim();
      }
      this.errorMessage = this.validate(data);
      if (this.errorMessage) {
        this.showErrorMessage = true;
        return;
      }
      this.showLoader();
      this.$http.post(
          Server_URL + '/auftragsbuch/basis_data/lears', data
      ).then(this.responseOkPost, this.responseError)
    },
    validate(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].name.trim() === "") {
          return "Der Name muss gesetzt sein."
        }
        if (data[i].legr.trim() === "") {
          return "Die Leistungsgruppe muss gesetzt sein."
        }
      }
      return "";
    },
    moveSelection(direction, gotToMax) {
      if (this.isDetail) {
        if (gotToMax) {
          this.currentItemIndex = direction === 'left' ? 0 : this.lears.length - 1;
        } else {
          this.currentItemIndex = direction === 'left' ? this.currentItemIndex - 1 : this.currentItemIndex + 1;
        }
        this.currentLear = this.lears[this.currentItemIndex];
      }
    },
    toggleDetails() {
      if (!this.isDetail) {
        this.currentLear = this.itemId ? this.lears.find(legr => legr.id === this.itemId) : this.lears[0];
        this.currentItemIndex = this.lears.findIndex(legr => legr.id === this.currentLear.id);
      } else {
        this.hasSelects = false;
        this.itemId = '';
      }

      this.isDetail = !this.isDetail;
      if (this.isDetail) {
        //this.$refs.detail.$emit('change', false);
      } else {
        this.$nextTick(() => {
          this.$refs.spreadsheet.mountSpreadsheet();
        });
      }
    },
    selectionChange(hasSelection, selection) {
      this.hasSelects = hasSelection;
      if ((!this.singleEdit || !this.isEdit)) {
        if (hasSelection) {
          this.itemId = this.lears[selection[0]].id;
        } else {
          this.itemId = '';
        }
      }
    },
    dblClick(index) {
      if (!this.isEdit) {
        this.itemId = this.lears[index].id;
        this.toggleDetails();
      }
    },
    resetEdit() {
      let deleteIndex = -1;
      for (let i = 0; i < this.lears.length; i++) {
        if (this.lears[i].id === this.editId && this.lears[i].bis_id === 'Neuanlage') {
          deleteIndex = i;
          break
        }
      }
      if (deleteIndex !== -1) {
        this.lears.splice(deleteIndex, 1);
      }
      if (!this.isDetail) {
        if (!this.singleEdit) {
          this.$nextTick(() => {
            this.$refs.spreadsheet.reload();
          });
        } else {
          let editId = this.editId;
          this.$nextTick(() => {
            this.$refs.spreadsheet.resetEdit(editId);
          });        }
      } else {
        if (this.currentLear.bis_id !== 'Neuanlage') {
          this.$refs.detail.resetEdit();
        } else {
          this.moveSelection('left', true)
        }
      }
      this.editId = '';
      this.isEdit = false;
    },
    addRow() {
      let d = {
        id: v4(),
        bis_id: 'Neuanlage',
        name: '',
        access: '',
        legr: '',
        lohn_surcharge: '',
      };
      this.lears.push(d);
      if(this.isDetail) {
        this.currentLear = d;
        this.currentItemIndex = this.lears.length - 1;
        this.editId = d.id;
        this.isEdit = true;
      } else {
        this.$refs.spreadsheet.addRow(d);
      }
    },
    dataChanged(id) {
      this.editId = id;
      if (!this.isDetail) {
        this.itemId = '';
      }
      this.isEdit = true;
    },
    showLoader() {
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    responseOkGet(response) {
      this.hideLoader();
      if (response.status === 200) {
        this.lears = response.body.lears;
        this.legrs = response.body.legrs;
        this.ezs = response.body.ezs;
        let possibleLegrs = this.legrs.map(k => k.name);
        let possibleEzs = this.ezs.map(k => {return {id: k.access, name: k.name}});
        this.cols[2].source = possibleLegrs;
        this.cols[3].source = possibleEzs;
        this.$nextTick(() => {
          this.$refs.spreadsheet.mountSpreadsheet();
        });
      } else {
        window.location = Redirect_500;
      }
    },
    responseOkPost(response) {
      this.hideLoader();
      if (response.status === 200) {
        let items = response.body;
        if (this.singleEdit || this.isDetail) {
          let k = items[0];
          for (let i = 0; i < this.lears.length; i++) {
            if (this.lears[i].id === k.id) {
              this.lears[i] = k;
              break;
            }
          }
          if (this.isDetail) {
            this.currentLear = k;
          } else {
            this.$refs.spreadsheet.updateRow(k);
          }
          this.editId = '';
          this.isEdit = false;
        } else {
          this.lears = items;
          this.$nextTick(() => {
            this.$refs.spreadsheet.reload();
          });
          this.editId = '';
          this.isEdit = false;
        }
        console.log(this.isEdit)
      } else {
        window.location = Redirect_500;
      }
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
  }

}
</script>

<style scoped>

.t-btn {
  height: 32px !important;
  width: 180px !important;
  max-width: 180px !important;
  min-width: 180px !important;
  margin: auto 12px auto 0px;
}

.t-btn-left {
  margin: auto 12px auto auto !important;
}


::v-deep label {
  margin-bottom: initial;
}

::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  cursor: pointer;
}

.theme--light.v-label {
  color: black;
}

.v-input--is-disabled::v-deep input {
  color: black;
}

::v-deep .theme--light.v-icon.v-icon.v-icon--disabled {
  color: rgb(84, 84, 84) !important;
}

.hidden {
  visibility: hidden;
}

::v-deep .jexcel_content {
  height: calc(100vh - 55px - 2.55rem - 24px);
}

::v-deep .jexcel_container {
  height: calc(100vh - 55px - 2.55rem - 15px);
}

</style>

